import { ChevronLeft, ChevronRight } from "lucide-react";

/**
 * "n/total" 과 붙은 두 화살표 버튼. 각진 사각형 + 두 버튼 붙임(공유 divider).
 * 순환 여부는 호출측이 정한다. DSD 리뷰의 합계 검증 패널과 근거 창이 쓴다
 */
export const PrevNextControl = ({
  index,
  total,
  prevLabel,
  nextLabel,
  onPrev,
  onNext,
}: {
  /** 0 부터. 음수면 1 로 보여준다 */
  index: number;
  total: number;
  prevLabel: string;
  nextLabel: string;
  onPrev: () => void;
  onNext: () => void;
}) => (
  <div className="flex items-center gap-3">
    <span className="label-2-medium tabular-nums">
      <span className="text-label-normal">{(index >= 0 ? index : 0) + 1}</span>
      <span className="text-label-alternative">/{total}</span>
    </span>
    <div className="flex divide-x divide-line-normal border border-line-normal">
      <button
        type="button"
        onClick={onPrev}
        aria-label={prevLabel}
        className="flex size-10 items-center justify-center text-label-normal transition-colors hover:bg-background-neutral-alternative"
      >
        <ChevronLeft className="size-4" />
      </button>
      <button
        type="button"
        onClick={onNext}
        aria-label={nextLabel}
        className="flex size-10 items-center justify-center text-label-normal transition-colors hover:bg-background-neutral-alternative"
      >
        <ChevronRight className="size-4" />
      </button>
    </div>
  </div>
);
